import React from 'react';
import './App.scss';
import {BillEntryProps} from "./components/billEntry/BillEntry";
import {BillResultProps} from "./components/billResult/BillResult";
import AreaView from "./views/Area.view";
import CompleteView from "./views/Complete.view";
import CompleteBrauBevView from "./views/CompleteBrauBev.view";
import {BillData} from "./@types/BillData";
import AreaBrauBevView from "./views/AreaBrauBev.view";

export interface AppProps {
    billHeader: string;
    boothHeader: string;
    boothEntry: BillEntryProps;
    billEntryHeader: string;
    billEntries: BillEntryProps[];
    billResult: BillResultProps;
    disclaimer: string;
    isComplete: boolean;
    date: string;
    event: "drinktec" | "braubev",
    billData: BillData,
}

const App = (props: AppProps) => {
    console.log(props, "props");
    if(props.event === "drinktec") {
        if(props.isComplete) {
            return <div className="App Complete">
                <CompleteView {...props} />
            </div>
        } else {
            return <div className="App Area">
                <AreaView {...props} />
            </div>
        }
    }
    if(props.event === "braubev") {
        if(props.isComplete) {
            return <div className="App">
                <CompleteBrauBevView {...props} />
            </div>
        } else {
            return <div className="App">
                <AreaBrauBevView {...props} />
            </div>
        }
    }
    return <b>Something went wrong - Did you add the &event flag to the url parameters?</b>
}

export default App;
